module.exports = new __parcel__URL__("bird04.f199626c.mp3").toString();